module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Verify your listing","message":{"0":"We found this business listing on Google","1":"Is this your business?"},"confirm":"Yes, use this listing","cancel":"No, let me try again","error":"Something went wrong and we could not load your reviews. Please try again."}}')
  delete Component.options._Ctor
}
